/**
 * Convert "my_cool_app" to "myCoolApp"
 */
export function snakeCaseToCamelCase(key: string) {
  return key
    .split("_")
    .map((s, i) => (i === 0 ? s : s[0].toUpperCase() + s.slice(1)))
    .join("");
}
